import { ModalService } from '@app/plugins/iview-modal-modify/service';
import { TemplateService } from '@mailer/services/TemplateService';
import CreateEditForm from '@mailer/components/templates/modal-create-edit-form';
import i18n from '@app/plugins/i18n';

class TemplateModalService extends ModalService {
  constructor() {
    super(TemplateService);
  }

  create(item = {}) {
    return this.$open({
      title: i18n.t('shared.component.modal.create'),
      width: this.size.confirm,
      render: h =>
        h(CreateEditForm, {
          props: {
            item: item
          },
          on: {
            success: data => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }

  remove(id, item) {
    return this.$removeItem(id, item, {
      content: i18n.t('mailer.template.modal.remove.content', {
        name: `<strong>${item.name}</strong>`
      })
    });
  }
}

const instance = new TemplateModalService();
export { instance as TemplateModalService };
